import { render, staticRenderFns } from "./OrganigramLoader.vue?vue&type=template&id=0e0f87d2&"
import script from "./OrganigramLoader.vue?vue&type=script&lang=js&"
export * from "./OrganigramLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports